import { PaginatedData } from "src/library/utils";
import useAxios from "src/core/shared/hooks/useAxios";
import type {
  IProduct,
  ListProductsParams
} from "src/core/products/api/products.api";
import {
  IUser,
  ListUsersParams
} from "src/core/users/api/users.api";
import {
  ICustomer,
  ListCustomersParams
} from "src/core/customers/api/customers.api";
import {
  ListDropsParams,
  IDrop
} from "src/core/drops/api/drops.api";

import {
  EndpointConfig,
  RequestConfig,
  UseApiRequest
} from "./config.api";

type SearchProductsParams = ListProductsParams;
type SearchUsersParams = ListUsersParams;
type SearchCustomersParams = ListCustomersParams;

type SearchProductsResponse = PaginatedData<IProduct>;
type SearchUsersResponse = PaginatedData<IUser>;
type SearchCustomersResponse = PaginatedData<ICustomer>;

type SearchEndpoints = {
  SEARCH_PRODUCTS: EndpointConfig<SearchProductsParams, SearchProductsResponse>;
  SEARCH_USERS: EndpointConfig<SearchUsersParams, SearchUsersResponse>;
  SEARCH_CUSTOMERS: EndpointConfig<SearchCustomersParams, SearchCustomersResponse>;
  SEARCH_DROPS: EndpointConfig<ListDropsParams, PaginatedData<IDrop>>;
};

const requests: RequestConfig<SearchEndpoints> = {
  SEARCH_PRODUCTS: params => ({
    url: `${process.env.REACT_APP_API_URL}/core/products`,
    method: "GET",
    params
  }),
  SEARCH_USERS: params => ({
    url: `${process.env.REACT_APP_API_URL}/core/users`,
    method: "GET",
    params
  }),
  SEARCH_CUSTOMERS: params => ({
    url: `${process.env.REACT_APP_API_URL}/core/customers`,
    method: "GET",
    params
  }),
  SEARCH_DROPS: params => ({
    url: `${process.env.REACT_APP_API_URL}/core/branches`,
    method: "GET",
    params
  })
};

export const useSearchApi: UseApiRequest<SearchEndpoints> = request => useAxios(requests[ request ], request);
